import React from "react";
import ReactSelect from "react-select";

const ReportFilter = ({ filters, filterChangeHandler, filterVal }) => {
  return filters.map((item) => {
    if (item.type === "Select") {
      const { options } = item;

      let newoptions = options.map((it) => ({
        label: it?.value,
        value: it.id,
      }));

      let value;
      if (item.hasOwnProperty("default_value") && item.default_value) {
        value = newoptions.find((it) => it.value === item.default_value);
      }
      return (
        <div class="col-md-3 pod-div-parent">
          <ReactSelect
            options={newoptions}
            isClearable
            defaultValue={value}
            value={filterVal[item?.field]}
            onChange={(e) => filterChangeHandler(e, item?.field)}
            placeholder={item.name}
          />
        </div>
      );
    }
  });
};

export default ReportFilter;
